import { BaseService } from 'core/services';
import FacilityAdditionalContactRouteService from './FacilityAdditionalContactRouteService';

class FacilityAdditionalContactService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new FacilityAdditionalContactRouteService());
    }
    bulkCreate(resources) {
        const url = this.routeService.bulkCreate(resources);
        return this.apiClient.post(url, resources)
    }
}

export default FacilityAdditionalContactService;
